import { render, staticRenderFns } from "./ModalSearch.vue?vue&type=template&id=4a4069e8&scoped=true&"
import script from "./ModalSearch.vue?vue&type=script&lang=ts&"
export * from "./ModalSearch.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSearch.vue?vue&type=style&index=0&id=4a4069e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4069e8",
  null
  
)

export default component.exports